import styled from "styled-components"

import { minWidth, when } from "utils"

import Grid from "components/grid"
import ClassCard from "components/card/class"

export const Wrapper = styled.div`
  padding: 4rem 2rem 6rem 2rem;
  background-image: url(https://www.mindbodygreen.com/img/patterns/wave-pattern.svg);
  background-repeat: repeat;
  margin-bottom: 8rem;
  ${minWidth.tablet`
    padding: 6rem 4rem;
  `}

  ${minWidth.desktop`
    padding: 8rem 4rem;
  `}
`

export const StyledGrid = styled(Grid)`
  padding: 0;
  background-color: transparent;

  ${minWidth.desktop`
    width: calc(100% - 100% * 2/12);
    margin-left: calc(100% * 1/12);
  `}

  h2 {
    border: none;
    text-align: center !important;

    ${minWidth.tablet`
      font-size: 2.2em;
    `}

    ${minWidth.desktop`
      width: calc(100% - 100% * 2/12);
      margin-left: calc(100% * 1/12);
      font-size: 3em;
    `}
  }
`

export const StyledCard = styled(ClassCard)`
  background-color: #fff;

  ${when("multiple")`
    /* header */
    > div {
      padding: 3rem 1.5rem;
    }
  `}
`

export const OneCardTitle = styled.h2`
  font-family: Abril, "Helvetica Neue", Helvetica, Arial, sans-serif;
  font-size: 1.85em;
  text-align: center;

  ${minWidth.tablet`
    font-size: 2.2em;
  `}

  ${minWidth.desktop`
    width: calc(100% - 100% * 2/12);
    margin-left: calc(100% * 1/12);
    font-size: 3em;
  `}
`
